import { render, staticRenderFns } from "./scroll_buttons.vue?vue&type=template&id=caa0c018&"
import script from "./scroll_buttons.vue?vue&type=script&lang=js&"
export * from "./scroll_buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports